import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Form, Grid, Segment, Message, Icon } from "semantic-ui-react";
import Header from "semantic-ui-react/dist/commonjs/elements/Header/Header";
import BotonGuardar from "../botones/BotonGuardar";
import CustomCheckbox from "../CustomCheckbox";

function renderTextField({
  input,
  meta: { touched, error, warning },
  ...others
}) {
  let color = touched && ((error && "red") || (warning && "yellow"));
  let mensaje =
    touched &&
    ((error && <span>{error}</span>) || (warning && <span>{warning}</span>));

  return (
    <div>
      <Form.Input {...input} {...others} />
      {touched &&
        ((error || warning) && (
          <Message negative>
            <Message.Header>
              <Icon
                name="warning circle"
                style={{
                  color
                }}
              />
              {mensaje}
            </Message.Header>
          </Message>
        ))}
    </div>
  );
}

function renderCheckbox({
  input,
  meta: { touched, error, warning },
  ...others
}) {
  return <CustomCheckbox {...input} {...others} />;
}

const iban1 = value =>
  value && !/^[ES]{2}\d{2}$/i.test(value) ? `ESXX` : null;

const iban = value => (value && !/^\d{4}$/i.test(value) ? `XXXX` : null);

const telefono = value =>
  value && !/^\d{9}$/i.test(value) ? "Incorrecto" : null;

const required = value => (value ? undefined : "Requerido");

class AlumnoForm extends React.Component {
  preSubmit = values => {
    values.iban = `${values.iban1} ${values.iban2} ${values.iban3} ${
      values.iban4
    } ${values.iban5} ${values.iban6}`;

    this.props.handleSubmit(values => this.props.action(values));
  };

  render() {
    const { handleSubmit, pristine, reset, submitSucceeded } = this.props;

    return (
      <Form>
        <Segment>
          <Grid columns="4">
            <Grid.Row>
              <Grid.Column>
                <label>
                  Nombre
                  <Field
                    id="nombre"
                    name="nombre"
                    type="text"
                    component={renderTextField}
                    validate={[required]}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Primer Apellido
                  <Field
                    required
                    id="apellido1"
                    name="apellido1"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Segundo Apellido
                  <Field
                    id="apellido2"
                    name="apellido2"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Edad
                  <Field
                    id="edad"
                    name="edad"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns="6">
            <Grid.Column>
              <Field
                id="hermanos"
                name="hermanos"
                type="checkbox"
                component={renderCheckbox}
                label="Hermanos"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                id="ampa"
                name="ampa"
                type="checkbox"
                component={renderCheckbox}
                label="AMPA"
              />
            </Grid.Column>
          </Grid>

          <Grid columns="3">
            <Grid.Row>
              <Grid.Column>
                <label>
                  Colegio donde estudia
                  <Field
                    id="colegioestudios.nombre"
                    name="colegioestudios.nombre"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Población
                  <Field
                    id="colegioestudios.poblacion"
                    name="colegioestudios.poblacion"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
              <Grid.Column>
                <label>
                  Provincia
                  <Field
                    id="colegioestudios.provincia"
                    name="colegioestudios.provincia"
                    type="text"
                    component={renderTextField}
                  />
                </label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        <Segment>
          <Header as="h4">Datos Contacto</Header>
          <Grid columns="3">
            <Grid.Column>
              <label>
                Persona de Contacto
                <Field
                  id="contacto"
                  name="contacto.nombre"
                  type="text"
                  component={renderTextField}
                />
              </label>
            </Grid.Column>
            <Grid.Column>
              <label>
                Parentesco
                <Field
                  id="contacto"
                  name="contacto.parentesco"
                  type="text"
                  component={renderTextField}
                />
              </label>
            </Grid.Column>
            <Grid.Column>
              <label>
                Teléfono de Contacto
                <Field
                  id="contacto"
                  name="contacto.telefono"
                  type="text"
                  component={renderTextField}
                  validate={[telefono]}
                />
              </label>
            </Grid.Column>
          </Grid>
        </Segment>

        <Segment>
          <Header as="h4">Datos de Cobro</Header>
          <Segment>
            <label>IBAN</label>
            <Grid columns="equal">
              <Grid.Column>
                <Field
                  id="iban1"
                  name="iban1"
                  type="text"
                  component={renderTextField}
                  validate={[iban1]}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  id="iban2"
                  name="iban2"
                  type="text"
                  component={renderTextField}
                  validate={[iban]}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  id="iban3"
                  name="iban3"
                  type="text"
                  validate={[iban]}
                  component={renderTextField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  id="iban4"
                  name="iban4"
                  type="text"
                  validate={[iban]}
                  component={renderTextField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  id="iban5"
                  name="iban5"
                  type="text"
                  validate={[iban]}
                  component={renderTextField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  id="iban6"
                  name="iban6"
                  type="text"
                  validate={[iban]}
                  component={renderTextField}
                />
              </Grid.Column>
            </Grid>
          </Segment>

          <Grid columns="4">
            <Grid.Column>
              <label>
                Concepto de Cobro
                <Field
                  id="conceptocobro"
                  name="conceptocobro"
                  type="text"
                  component={renderTextField}
                />
              </label>
            </Grid.Column>
            <Grid.Column>
              <label>
                Importe
                <Field
                  id="importe"
                  name="importe"
                  type="text"
                  component={renderTextField}
                />
              </label>
            </Grid.Column>
          </Grid>
        </Segment>
        <Segment basic padded="very">
          <BotonGuardar
            disabled={pristine || submitSucceeded}
            floated="right"
            buttontext="Guardando"
            icon="checkmark"
            action={handleSubmit(values => {
              values.iban = `${values.iban1} ${values.iban2} ${values.iban3} ${
                values.iban4
              } ${values.iban5} ${values.iban6}`;
              this.props.action(values);
            })}
          />
          <BotonGuardar
            disabled={pristine || submitSucceeded}
            floated="right"
            buttonText="Descartar Cambios"
            icon="cancel"
            action={reset}
          />
        </Segment>
      </Form>
    );
  }
}

AlumnoForm.propTypes = {
  action: PropTypes.func.isRequired
};

export default reduxForm({
  form: "FormularioAlumno",
  enableReinitialize: true
})(AlumnoForm);



// WEBPACK FOOTER //
// ./src/pages/shared/alumnos/AlumnoForm.jsx